<!--
 * @Author: 71
 * @Date: 2025-03-17 10:28:44
 * @LastEditTime: 2026-06-15 10:09:41
 * @LastEditors: 71
 * @Description:
 * @FilePath: \aigoes-school-web\src\views\school\AppPage\ HundredDayOath\index.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <div style="padding: 0 20px; background: #fff">
    <a-tabs :activeKey="activeKey" destroyInactiveTabPane @change="changeTab">
      <a-tab-pane v-for="(item, index) in tabList" :key="item.key" :tab="item.tab">
        <!--        <DayOathCard ref="schemeCardRef" actionUrl="ceremony" :cardList="cardList" />-->
        <component :is="item.type" ref="paneRef" actionUrl="ceremony" />
        <!-- <DayOathCard ref="schemeCardRef" actionUrl="ceremony" /> -->
      </a-tab-pane>
      <!-- <a-button type="primary" slot="tabBarExtraContent" @click="createLeague">创建</a-button> -->
    </a-tabs>
  </div>
</template>
<script>
// import SchemeCard from '@/comUi/SchemeCard/components/SchemeCard.vue'
import ActivityPane from './compoents/ActivityPane'
import ActivityDayOathPane from './compoents/ActivityDayOathPane'
import ActivityAppV2Pane from './compoents/ActivityAppV2Pane'
import ActivityEmotionSpacePane from './compoents/ActivityEmotionSpacePane'
import { deleteAction, getAction } from '@api/manage'

export default {
  name: 'HundredDayOath',
  components: {
    // SchemeCard,
    ActivityPane,
    ActivityDayOathPane,
    ActivityAppV2Pane,
    ActivityEmotionSpacePane,
  },
  data() {
    return {
      activeKey: '1',
      tabList: [
        {
          tab: '情绪空间-免费试用工作台',
          type: 'ActivityEmotionSpacePane',
          key: '1',
        },
        {
          tab: '情绪空间-C端活动工作台',
          type: 'ActivityAppV2Pane',
          key: '2',
        },
        {
          tab: '活动列表',
          type: 'ActivityPane',
          key: '3',
        },
        {
          tab: '百日誓师-工作台',
          type: 'ActivityDayOathPane',
          key: '4',
        },
      ],
    }
  },
  created() {
    const backKey = this.$router.history.current.query.activeKey
    if (backKey) {
      this.activeKey = backKey
    }
  },
  methods: {
    // createLeague() {
    //   this.$refs.schemeCardRef[0].showCardModal()
    // },
    changeTab(key) {
      this.activeKey = key
    },
  },
}
</script>
